<div class="fc-contact-host">
    <h1> Get in touch</h1>
    <div class="fc-contact-description">
        <p>Our team is happy to answer questions about Fair Comparison and how we can help you.</p>
        <p>Please use the contact form below.</p>
    </div>
    <div class="fc-form">
        <fc-hubspot-form-component></fc-hubspot-form-component>
    </div>
</div>